export const baseCmsUrl = process.env.VUE_APP_BASE_CMS_URL;
export const baseCmsNode = process.env.VUE_APP_BASE_CMS_NODE;